import * as s from '~js/utils/selectors';

export class IconsRow {
  constructor(section) {
    this.container = section.container;
    this.slider = this.container.querySelector(s.selectors$k.slider);
  }

  onBlockSelect(evt) {
    const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
    const sliderPadding = parseInt(sliderStyle.paddingLeft);
    const blockPositionLeft = evt.target.offsetLeft - sliderPadding;

    this.slider.scrollTo({
      top: 0,
      left: blockPositionLeft,
      behavior: 'smooth',
    });
  }
}